import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useTheme } from 'styled-components';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { TRANSFER_OWNERSHIP } from '../utilities/mutations';

const TransferOwnershipModal = ({ member, onClose }) => {
  const params = useParams();
  const theme = useTheme();
  const toast = useToast();
  const [transferOwnership] = useMutation(TRANSFER_OWNERSHIP);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()}>
      <ModalName>Transfer ownership</ModalName>
      <Formik
        initialValues={{ name: '' }}
        onSubmit={async (values) => {
          if (values.name !== member.user.name) {
            toast({ children: 'Name is invalid' });
          } else {
            try {
              await transferOwnership({
                variables: {
                  spaceSlug: params.s,
                  ownerId: member.user.id,
                },
              });

              toast({ children: `${member.user.name} is now owner` });
              close();
            } catch (error) {
              toast({ children: error.message });
            }
          }
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <ModalPart>
              <div
                style={{
                  color: theme.alias.subtle,
                  lineHeight: '20px',
                  fontWeight: 500,
                }}
              >
                You will lose ownership permissions immediately.
              </div>
              <Field>
                <FieldLabel>
                  Confirm the user name ({member.user.name})
                </FieldLabel>
                <FieldInput
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  data-autofocus
                />
              </Field>
            </ModalPart>
            <ModalPart>
              <Button type="button" onClick={() => onClose()} isExtended>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting || values.name !== member.user.name}
                isDanger
                isExtended
              >
                Transfer
              </Button>
            </ModalPart>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default TransferOwnershipModal;
